import { Table, TableBody, ButtonGroup, Modal, TableCell, TableContainer, TableHead, TableRow, AppBar, Box, Toolbar, TextField, useTheme, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Typography, Divider, CssBaseline, Badge } from "@mui/material";
import { useEffect, useState } from "react";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import HelpIcon from '@mui/icons-material/HelpOutline';
import CloseIcon from '@mui/icons-material/Close';
import Close from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import { tokens } from "../../../theme/theme";
// import '../../../components/boxstyles.css';
import Searchicon from '@mui/icons-material/Search';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

import CustomTableContainer from "../../../Layout/CustomTableContainer";
import useDepartment from "../../../hooks/useDepartment";
import useRequestIndentNumberListByDepartment from "../../../hooks/useRequestIndentNumberByDepartmentID";
import useVendorQuoteComparisonList from "../../../hooks/useVendorQuoteComparisonList";
import AddCompareVendorQuotations from "./AddCompareVendorQuotations";
import useVendorEnquiryComparisonList from "../../../hooks/purchase/useVendorEnquiryComparisionList";
import dayjs from "dayjs";
import { ViewList } from "@mui/icons-material";
import useVendorQuotationList from "../../../hooks/useVendorQuotationList";
import VendorResponse from "../vendor-quotation/VendorResponse";

const QuotationList = ({ handleBackWinderMachineEntry, formMode, showOnlyApprovedComparisions = false, poMode }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const formatDate = (d) => {
        if (!d) return "";

        const parsed = dayjs(d, [
            "DD-MM-YYYY HH:mm:ss",
            "DD-MM-YYYY",
            "YYYY-MM-DD HH:mm:ss",
            "YYYY-MM-DD"
        ]);

        return parsed.isValid() ? parsed.format("DD-MMM-YYYY") : "";
    };

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Quote Comparison');
    const [selectedStatus, setSelectedStatus] = useState('All');
    const openFirst = Boolean(anchorElFirst);
    const [newRequestIndent, setNewRequestIndent] = useState(false);
    const [requestIndentHome, setRequestIndentHome] = useState(true);

    const [selectedRows, setSelectedRows] = useState([]);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [showNewToolbar, setShowNewToolbar] = useState(false);

    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const [open, setOpen] = useState(false);
    const openSecond = Boolean(anchorElSecond);
    const [VendorQuotationNotification, setVendorQuotationNotification] = useState(0);
    const [viewQuotationListUI, setViewQuotationListUI] = useState(false);

    const [enquiryhdrid, setEnquiryhdrid] = useState(0);
    const { vendorQuoteComparisonList, loadVendorQuoteComparisonByID, } = useVendorQuoteComparisonList('');
    const { selectedDepartment, loadDepartmentByID } = useDepartment(0);
    const { selectedRequestIndentNumberList, loadIndentNumbersByDepartmentID } = useRequestIndentNumberListByDepartment(0);
    const {
        comparisonList,
        selectedComparison,
        selectedComparisonID,
        setSelectedComparison,
        loadComparisonByID
    } = useVendorEnquiryComparisonList();

    const { vendorQuotationList, loadVendorQuotationByID, } = useVendorQuotationList('Supplier quotation');
    const [selectedDepartmentParams, setSelectedDepartmentParams] = useState(null);
    const [selectedRequestIndentNumberListParams, setSelectedRequestIndentNumberListParams] = useState(null);

    useEffect(() => {
        const createdCount = vendorQuotationList.filter(
            item => item?.status === "pending"
        ).length;

        setVendorQuotationNotification(createdCount);
    }, [vendorQuotationList]);

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Quote Comparison') {
            setSelectedStatus('All');
        }
        else if (option === 'Partially Quote Comparison') {
            setSelectedStatus('Partially Quote Comparison');
        }

        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };

    const [comparisionID, setComparisionID] = useState(0);
    const [comparisionStatus, setComparisionStatus] = useState('');
    const handleShowNewVendor = () => {
        setComparisionID(0);
        setRequestIndentHome(false);
        setNewRequestIndent(true);
    }

    const handleCallEdit = async (row) => {
        setComparisionID(row.id);
        setRequestIndentHome(false);
        setNewRequestIndent(true);
        const selectedDepartment = await loadDepartmentByID(row.id_department);
        setSelectedDepartmentParams(selectedDepartment);
        const selectedRequestIndentNumberList = await loadIndentNumbersByDepartmentID(row.id_department, 'vendor enquiry', row.id_purchase);
        setSelectedRequestIndentNumberListParams(selectedRequestIndentNumberList);
        setComparisionStatus(row.status);
        setEnquiryhdrid(row.id_enquiry_hdr);
    };

    const handlecallback = () => {
        setRequestIndentHome(true);
        setNewRequestIndent(false);
        loadVendorQuoteComparisonByID();
        loadComparisonByID();
        setViewQuotationListUI(false);
        loadVendorQuotationByID();

    }

    const handleShowVendorQuotationList = () => {
        setRequestIndentHome(false);
        setNewRequestIndent(false);
        setViewQuotationListUI(true);
    }




    const [filters, setFilters] = useState({
        department: '',
        purchase_indent_number: '',
        enquiry_date: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };





    // const filteredData = comparisonList.filter((row) => {
    //     // Check if row matches selected status

    //     if (selectedStatus === 'All' || row.status === selectedStatus) {
    //         // Check if all filter fields match
    //         return Object.keys(filters).every((key) => {
    //             if (filters[key] === '') return true; // No filter applied
    //             return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
    //         });
    //     }
    //     return false;
    // });
    const filteredData = comparisonList.filter((row) => {
        // 🔒 Force Approved only when toggle is ON
        if (showOnlyApprovedComparisions && row.status !== 'Approved') {
            return false;
        }

        // Existing status filter logic
        if (selectedStatus !== 'All' && row.status !== selectedStatus) {
            return false;
        }

        // Text filters
        return Object.keys(filters).every((key) => {
            if (!filters[key]) return true;
            return String(row[key])
                .toLowerCase()
                .includes(filters[key].toLowerCase());
        });
    });


    const handleNewToolbarClose = () => {
        setShowNewToolbar(false); // Hide new toolbar
        setShowFirstToolbar(true);
    };



    const handleBulkUpdate = () => {
        console.log('Bulk Update');
    };

    const handleMarkAsIssued = () => {
        console.log('Mark as Issued');
    };

    const handleBulkCancelItems = () => {
        console.log('Bulk Cancel Items');
    };

    const handleBulkReopenCancelledItems = () => {
        console.log('Bulk Reopen Cancelled Items');
    };

    const handleConvertToBill = () => {
        console.log('Convert to Bill');
    };


    return (
        <Box >
            <CssBaseline />
            {requestIndentHome && (

                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        {showFirstToolbar && (
                            <>
                                <Button
                                    color="secondary"
                                    onClick={handleMenuClickFirst}
                                    endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                                    sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                                >
                                    {selectedOptionFirst}
                                </Button>
                                <Menu
                                    anchorEl={anchorElFirst}
                                    open={openFirst}
                                    onClose={handleMenuCloseFirst}

                                >
                                    <MenuItem onClick={() => handleMenuItemClickFirst('All Quote Comparison')}>All </MenuItem>
                                    {/* <MenuItem onClick={() => handleMenuItemClickFirst('Partially Quote Comparison')}>Partially Quote Comparison</MenuItem> */}
                                    {/* <MenuItem onClick={() => handleMenuItemClickFirst('Un Approved Request Indent')}>Un Approved Request</MenuItem> */}

                                </Menu>
                                {!poMode && (
                                    <Button size="small" variant="contained" onClick={handleShowVendorQuotationList} color="secondary"
                                        startIcon={
                                            <Badge
                                                badgeContent={VendorQuotationNotification}
                                                color="error"
                                                overlap="circular"
                                                sx={{
                                                    "& .MuiBadge-badge": {
                                                        fontSize: "10px",
                                                        height: "16px",
                                                        minWidth: "16px",
                                                        padding: "0 4px",
                                                    },
                                                }}
                                            >
                                                <ViewList sx={{ fontSize: "18px" }} />
                                            </Badge>
                                        } sx={{ marginLeft: 'auto', textTransform: 'none', marginRight: '5px' }}>
                                        View Vendor Quotation list
                                    </Button>
                                )}
                                {/* Adding margin-left: auto to push the button to the right */}
                                {/* <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} >New</Button> */}

                                {/* Second Menu */}
                                <IconButton
                                    size="small"
                                    // edge="start"
                                    color="secondary"
                                    aria-label="menu"
                                    sx={{ ml: poMode ? "auto" : 2 }}
                                    onClick={handleMenuClickSecond}
                                >
                                    <MoreVertIcon sx={{ fontSize: "18px" }} />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorElSecond}
                                    open={openSecond}
                                    onClose={handleMenuCloseSecond}
                                >
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendor Quotation')}>
                                        <ListItemIcon>
                                            <ImportExportIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Import Vendor Quotation" />
                                    </MenuItem>
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendor Quotation')}>
                                        <ListItemIcon>
                                            <FileDownloadIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Export Vendor Quotation" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                        <ListItemIcon>
                                            <ListAltIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Preference " />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                        <ListItemIcon>
                                            <RefreshIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Refresh List" />
                                    </MenuItem>
                                    <Divider />
                                    <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                        <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                            Reset Columns Width
                                        </Button>
                                    </MenuItem>
                                </Menu>

                                <IconButton
                                    size="small"
                                    // edge="start"
                                    // color="inherit"
                                    aria-label="menu"
                                    sx={{ mr: 1, ml: 1 }}
                                    onClick={handleMenuClickSecond}
                                >
                                    <HelpIcon sx={{ fontSize: "18px" }} />
                                </IconButton>
                                <div>
                                    <IconButton onClick={handleBackWinderMachineEntry} >
                                        <Close fontSize="inherit" style={{ color: "#2196F3", fontSize: "18px" }} />
                                    </IconButton>
                                </div>
                            </>
                        )}

                        {showNewToolbar && (
                            <>
                                <Button
                                    variant="outlined"
                                    color="secondary"

                                    onClick={handleMenuClickFirst}
                                    endIcon={<ArrowDropDownIcon sx={{ color: "teal" }} />}
                                    sx={{ textTransform: 'none', fontSize: "10px", fontWeight: "bold" }}
                                >
                                    {/* {selectedOptionFirst} */}
                                    <Typography variant="h6">
                                        Bulk Updates
                                    </Typography>
                                </Button>
                                <Menu
                                    anchorEl={anchorElFirst}
                                    open={openFirst}
                                    onClose={handleMenuCloseFirst}

                                >
                                    <MenuItem onClick={() => handleBulkUpdate()}>Bulk Update </MenuItem>
                                    <MenuItem onClick={() => handleMarkAsIssued()}>Mark as Issued</MenuItem>
                                    <MenuItem onClick={() => handleBulkCancelItems()}>Bulk Cancel Items</MenuItem>
                                    <MenuItem onClick={() => handleBulkReopenCancelledItems()}>Bulk reopen Canceled items</MenuItem>
                                    <MenuItem onClick={() => handleConvertToBill()}>Convert to Bill</MenuItem>
                                    {/* <MenuItem onClick={() => handleMenuItemClickFirst('Billed Purchase Orders')}>Billed</MenuItem> */}
                                </Menu>



                                <ButtonGroup color="secondary" variant="outlined" style={{ marginLeft: 10 }}>
                                    <Button aria-label="email" sx={{ padding: "6px", minWidth: 40 }}>
                                        <EmailIcon style={{ fontSize: "20px", color: "#5c6bc0" }} />
                                    </Button>
                                    <Button aria-label="pdf" sx={{ padding: 0, minWidth: 40 }}>
                                        <PictureAsPdfIcon style={{ fontSize: "20px", color: "#d32f2f" }} />
                                    </Button>
                                    <Button aria-label="print" sx={{ padding: 0, minWidth: 40 }}>
                                        <PrintIcon style={{ fontSize: "20px", color: "#64b5f6" }} />
                                    </Button>
                                </ButtonGroup>
                                <ButtonGroup color="secondary" variant="outlined" style={{ marginLeft: 10 }}>
                                    <Button aria-label="delete" sx={{ padding: "6px", minWidth: 40 }}>
                                        <DeleteIcon style={{ fontSize: "20px", color: "#ff7043" }} />
                                    </Button>
                                </ButtonGroup>
                                <IconButton size="small" aria-label="close" sx={{ marginLeft: 2 }} >
                                    <FiberManualRecordIcon sx={{ fontSize: "12px", color: "green" }} />
                                </IconButton>
                                <Typography variant="h6" >
                                    {`${selectedRows.length} Purchase Order${selectedRows.length > 1 ? 's' : ''} selected`}
                                </Typography>


                                <IconButton size="small" aria-label="close" sx={{ marginLeft: 'auto', mr: 1 }} onClick={handleNewToolbarClose}>
                                    <CloseIcon />
                                </IconButton>
                            </>
                        )}
                    </Toolbar>
                </AppBar>
            )}

            {requestIndentHome && (

                <CustomTableContainer colors={colors}>
                    <TableContainer >
                        <Table size="small">
                            <TableHead sx={{ height: 10 }}>
                                <TableRow>
                                    <TableCell>QUOTE COMPARISON ID / DATE</TableCell>

                                    <TableCell>REMARKS</TableCell>
                                    <TableCell>CREATED BY</TableCell>
                                    <TableCell>STATUS</TableCell>
                                    <TableCell>
                                        <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "16px" }} />
                                        </IconButton>
                                        <Modal
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>

                                                <TextField
                                                    label="Purchase Indent Number"
                                                    name="purchase_indent_number"
                                                    value={filters.purchase_indent_number}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    size="small"
                                                    margin="normal"
                                                    color="secondary"
                                                />



                                                <TextField
                                                    label="Department"
                                                    name="department"
                                                    value={filters.department}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                    color="secondary"
                                                />




                                                <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button>
                                            </Box>
                                        </Modal>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell>
                                            <span
                                                style={{ color: "teal", textDecoration: "underline", cursor: "pointer" }}
                                                onClick={() => handleCallEdit(row)}
                                            >
                                                {row.id} / {formatDate(row.comparison_date)}
                                            </span>
                                        </TableCell>




                                        <TableCell>{row.remarks}</TableCell>
                                        <TableCell>{row.created_by}</TableCell>
                                        <TableCell>
                                            {row.status?.toLowerCase() === "converted"
                                                ? "PO Generated"
                                                : row.status?.toLowerCase() === "pending"
                                                    ? "Pending"
                                                    : row.status}
                                        </TableCell>


                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTableContainer>
            )}

            {/* New Vendor */}
            {newRequestIndent && (
                <AddCompareVendorQuotations
                    key={enquiryhdrid}
                    handlecallback={handlecallback}
                    quotationData={comparisionID}
                    selectedRequestIndentNumberList={selectedDepartment}
                    selectedVendoIdListID={selectedRequestIndentNumberList}
                    comparisionStatus={comparisionStatus}
                    showOnlyApprovedComparisions={showOnlyApprovedComparisions}
                    para_selectedDepartment={selectedDepartmentParams} />



            )}
            {viewQuotationListUI && (
                <VendorResponse handleBackWinderMachineEntry={handlecallback} showOnlyPendingQuotations={true} comparisonMode={true}/>
            )}

        </Box>
    );
}

export default QuotationList;





